import React from 'react';
import './AdminTableCategories.scss';

import TableCategories from './TableCategories/TableCategories';
import { allCategoriesLoad, openAddInputFormsForCategories  } from '../../../adminSlice';

export default class AdminTableCategories extends React.Component {
    constructor(props) {
        super(props);

        this.onAdd = this.onAdd.bind(this);
        this.onGetAllCategories = this.onGetAllCategories.bind(this);
    }

//GET ALL CATEGORIES
onGetAllCategories() {
    const { dispatch } = this.props;
    //console.log(this.props.adminState.dataQuizes);
    
    dispatch(allCategoriesLoad());
}
onAdd() {
    const { dispatch } = this.props;

    dispatch(openAddInputFormsForCategories());
   
}



    render() {

    /*
    // НЕ ПОНЯТНО ЗАЧЕМ ISFETCHING  
    const  {dataTable, isFetching, error} = this.state;  
    if (isFetching) return <div>...Loading</div>;
    if (error) return <div>{`Error: ${error}`}</div>;
*/ 
let style;
            
if (this.props.adminState.dataCategories.length !== 0) {
    console.log(this.props.adminState.dataCategories)
        style = ''
    } else {
        style = 'disabled'
    }
    const { dispatch} = this.props;

   

        return (
            
            <div className="AdminTableCategories">
                
                <button className='updateButton' onClick={this.onGetAllCategories}></button>
                   <p className='tableName'>Список категорий</p>
                   
                   
                   <div >
                    
                   </div>
                   <TableCategories 
                   userId={this.props.userId}
                   dispatch={dispatch}
                   data={this.props.adminState.dataCategories}
                   />

                <button className='addButton'onClick={this.onAdd} disabled={style}>{/*<i className="fas fa-plus"></i>*/}</button>

                
            </div>
        )
    }
}

